module.exports = __webpack_public_path__ + "img/129.5.e2f30a06.png";